var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H11.1562L11.4688 2.15625C11.5625 1.59375 11.1875 1.09375 10.6562 1C10.0938 0.90625 9.59375 1.28125 9.5 1.8125L9.125 4H6.15625L6.46875 2.15625C6.5625 1.59375 6.1875 1.09375 5.65625 1C5.09375 0.90625 4.59375 1.28125 4.5 1.8125L4.125 4H2C1.4375 4 1 4.4375 1 5C1 5.5625 1.4375 6 2 6H3.8125L3.125 10H1C0.4375 10 0 10.4375 0 11C0 11.5312 0.4375 11.9688 1 11.9688H2.8125L2.5 13.7812C2.40625 14.3438 2.78125 14.8438 3.3125 14.9375C3.375 15 3.4375 15 3.5 15C3.96875 15 4.375 14.6562 4.46875 14.1875L4.84375 12H7.8125L7.5 13.8438C7.40625 14.4062 7.78125 14.9062 8.3125 15C8.375 15 8.4375 15 8.5 15C8.96875 15 9.375 14.6562 9.46875 14.1875L9.84375 12H12C12.5312 12 13 11.5625 13 11.0312C13 10.5 12.5312 10.0312 12 10.0312H10.1562L10.8438 6.03125H13C13.5312 6.03125 14 5.59375 14 5.0625C14 4.46875 13.5312 4 13 4ZM8.125 10H5.15625L5.84375 6H8.8125L8.125 10Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.c04baa6004befe4788064538cddfc7c5.svg";
export { ForwardRef as ReactComponent };